import React, { useEffect, useState } from "react";
import Axios from 'axios';
import { useNavigate } from "react-router-dom";
import { SnackbarProvider, useSnackbar } from 'notistack';
import Navbar from "../../../components/Navbar";
import Background from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import SubmitButton from "../../../components/Button";
import MaskedInput from "../../../components/InputMask";
import style from "./CadastroNavio.module.css";

const CadastroNavio = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [nome, setNome] = useState("");
  const [imo, setImo] = useState("");
  const [bandeira, setBandeira] = useState("");
  const [loa, setLoa] = useState("");
  const [bridge, setBridge] = useState("");
  const [detailedVesselType, setDetailedVesselType] = useState("");
  const [cargoHolds, setCargoHolds] = useState("");
  const [gear, setGear] = useState("");

  const usuario = JSON.parse(localStorage.getItem("user_token")).id;

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  }

  const validaDados = () => {
    if (!nome || !imo || !bandeira) {
      showAlert('Preencha todos os campos!', 'error');
      return;
    }
    if (imo.length < 8) {
      showAlert('IMO deve conter 8 dígitos!', 'error');
      return;
    }
    addNavio();
  }

  const addNavio = () => {
    const payload = {
      nome, imo, bandeira, status: 'AGUARDANDO INÍCIO DA VIAGEM', usuario, loa,
      bridge, detailedVesselType, cargoHolds: parseInt(cargoHolds, 10), gear
    };

    Axios.post('https://operacao.setlogistica.com.br/api/navio/criar', payload)
      .then((res) => {
        if (res.data.sqlMessage) {
          showAlert(res.data.sqlMessage, 'error');
        } else {
          showAlert('Navio cadastrado com sucesso!', 'success');
          setTimeout(() => navigate("/api/navios"), 2000);
        }
      });
  };

  return (
    <>
      <Navbar navios />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
        <div className={style.nav}>
          <div className={style.navItem} onClick={() => navigate("/navios/cadastro")}>
            Navios  
          </div>
        <div className={style.navItemActive}>
          {'>'}  Cadastrar Navio
        </div>
          
        </div>

          <div className={style.formGrid}>
            <Input type="text" text="NAVIO (*)" onChange={(e) => setNome(e.target.value.toUpperCase())} />
            <MaskedInput text="IMO (*)" name="IMO" mask="99999999" value={imo} placeholder="00000000" onChange={(e) => setImo(e.target.value)} />
            <Input type="text" text="BANDEIRA (*)" placeholder="ex: China" onChange={(e) => setBandeira(e.target.value.toUpperCase())} />
            <Input type="text" text="LOA (m)" placeholder="Comprimento total" onChange={(e) => setLoa(e.target.value.replace(',', '.'))} />
            <Input type="text" text="Bridge (m)" placeholder="Bridge Height" onChange={(e) => setBridge(e.target.value.replace(',', '.'))} />
            <select className={style.select} value={detailedVesselType} onChange={(e) => setDetailedVesselType(e.target.value)}>
              <option value="">Selecione Vessel Type</option>
              <option value="Container Ship">Container Ship</option>
              <option value="Bulk Carrier">Bulk Carrier</option>
              <option value="Tanker">Tanker</option>
              <option value="Gas Carrier">Gas Carrier</option>
              <option value="Chemical Tanker">Chemical Tanker</option>
              <option value="Outros">Outros</option>
            </select>
            <Input type="number" text="Cargo Holds" placeholder="Número de Carga" min="0" onChange={(e) => setCargoHolds(e.target.value)} />
            <Input type="text" text="Gear" placeholder="Enter Gear" onChange={(e) => setGear(e.target.value)} />
          </div>

          <SubmitButton text="Cadastrar" onClick={validaDados} className={style.submitButton} />
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider anchorOrigin={{ vertical: "bottom", horizontal: "right" }} maxSnack={3} autoHideDuration={2500}>
      <CadastroNavio />
    </SnackbarProvider>
  );
};
